
import { Button, FormControl, FormControlLabel, Radio, RadioGroup} from '@mui/material';
import { useEffect } from 'react';
//import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
//import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom/dist';
import Swal from 'sweetalert2';

import { buttonStyles, buttonStylesGreen } from '../../../Components/docsAdministrative/JsObjectStyles';
import {IconTextField, TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
import { MonthsString } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useRole from '../../../hooks/useRole';
import { getNomPrenomClearFromPersoData, searchLabelInEnumByValue } from '../../../Utils/utils';
import NomRefRgularisationNormal from './NomRefRgularisationNormal';

const RegularizationNormal = () => {
    const { state } = useLocation();
    const [refCra,setRefCra]=useState('');
    const [craId,setCraId]=useState('');
    const [refMission,setRefMission]=useState('');
    const [nomClient,setNomClient]=useState('');
    const [refClient,setRefClient]=useState('');
    const [refExpert,setRefExpert]=useState('');
    const [nomExpert,setNomExpert]=useState('');
    const [refIntClient, setRefIntClient] = useState('');
    const [refCmdClient, setRefCmdClient] = useState('');
    const [date,setDate]=useState('');
    // const [data,setData]=useState([]);
    const [ajoutDeduire,SetAjoutDeduire]=useState();
    const [nbrJour,setNbrJour]=useState();
    const [tjExpert,setTjExpert]=useState();
    const [tjClient,setTjClient]=useState();
    const [TotalExpert,setTotalExpert]=useState();
    const [TotalClient,setTotalClient]=useState();
    const [detail,setDetail]=useState('');
    const { i18n } = useTranslation();
    let navigate = useNavigate();
    const role = useRole();
    const axiosPrivate = useAxiosPrivate();

    const disabledParam = (role == 'client' || role == 'expert' || role=='esn');

    useEffect(() => {
        if(refCra && (!state?.rowData?.refCra))
            getCraByRef();
    }, [refCra]);

    // useEffect(() => {
    //     if(data){
    //         initializeRegNormal(data);
    //     }
    // }, [data]);
    const initializeRegNormal = (cra) =>{
        setRefCra(cra?.craId);
        setCraId(cra?._id);
        setRefMission(cra?.missionId?.missionId);
        setRefClient(cra?.missionId?.companyDataId?.clientId ?? cra?.missionId?.esnId?.esnId);
        setNomClient(cra?.missionId?.companyDataId?.profileEntreprise?.nom ?? cra?.missionId?.esnId?.profileEntreprise?.nom );
        setRefExpert(cra?.missionId?.expertId?.expertId);
        setRefCmdClient(cra?.bdcId?.refCmdClient);

        setNomExpert(getNomPrenomClearFromPersoData(cra?.missionId?.expertId?.persoData));
        let temp=searchLabelInEnumByValue(MonthsString,cra?.month);
        setDate([temp,cra?.year].join(' ')); //j'ai travailler avec cette methode pour resolu le prblm d'affichage(janvier,,,,,,, 2023)
        setTjClient(cra?.tjClient);
        setTjExpert(cra?.tj);
    };

    useEffect(() => {
        //TODO: to complete later on, those are the first steps to do an update by the admin, starting by loading the right data
        if (state?.rowData?.refCra) {
            // const regularisationX = state?.rowData;
            // alert(JSON.stringify(state?.rowData?.files));
            console.log('refCra', state?.rowData?.refCra);
            initializeRegNormal(state?.rowData[state?.rowData?.isCraOrCraX]);
            setRefIntClient(state?.rowData?.refIntClient);
            setNbrJour(state?.rowData?.nbrUnite);
            setTotalClient(state?.rowData?.montantTotalClient);
            setTotalExpert(state?.rowData?.montantTotal);
            if (state?.rowData?.montantTotalClient>0 && state?.rowData?.montantTotal>0)
                SetAjoutDeduire('ajouter');
            else
                SetAjoutDeduire('deduire');
            setDetail(state?.rowData?.details);
            //setFileList(filesAddapter(state?.rowData?.files));
        }
    }, [state]);

    useEffect(() => {
        console.log('nbrJour',nbrJour,'ajoutDeduire',ajoutDeduire);
        if(ajoutDeduire && nbrJour){
            console.log('ajoutDeduire==ajouter && TotalClient <0',ajoutDeduire=='ajouter' && TotalClient <0);
            //|| (ajoutDeduire=='ajouter' && TotalClient <0 ))
            if(ajoutDeduire=='deduire'){
                setTotalClient(tjClient*nbrJour*(-1));
                setTotalExpert(tjExpert*nbrJour*(-1));
            }
            else{
                setTotalClient(tjClient*nbrJour);
                setTotalExpert(tjExpert*nbrJour);
            }
        }
    }, [ajoutDeduire,nbrJour]);

    const getCraByRef = async () => {
        try {
            //TS-202020 pour le test
            const response = await axiosPrivate.get('cra/getCraByRef/'+refCra);
            // setData(response?.data);
            initializeRegNormal(response?.data);
        }catch(error) {
            console.log(error);
            // ! reg already created
            if(error?.response?.status == 400){
                Swal.fire({
                    icon: 'error',
                    // title: 'Oops...',
                    text: error?.response?.data?.error,
                });
            }
            // setData([]);
            initializeRegNormal(null);
        }
    };

    const createRegNormal = async (e) => {
        e.preventDefault();
        try {
            const response1 = await axiosPrivate.post('facture/createRegularisation', {
                craId: craId,
                nbrUnite: nbrJour,
                montantTotal: TotalExpert,
                montantTotalClient: TotalClient,
                details: detail,
            });

            console.log(response1);
            // If the first request is successful, proceed with the second request
            const response2 = await axiosPrivate.post('/facture/updateRefIntClient', {
                'refIntClient': refIntClient,
                'type': 'regularisation',
                'craId': craId,
            });

            console.log(response2);
            // Assuming success, show success message and navigate
            Swal.fire({
                icon: 'success',
                text: i18n.t('La régularisation a été créée avec succès!'),
                confirmButtonColor: '#5CC889',
            });
            navigate(-1);

        } catch (error) {
            // Handle any errors that occurred in either request
            console.error(error);
            Swal.fire({
                icon: 'error',
                text: i18n.t(error?.response?.data?.error),
            });
        }

    };

    return (
        <form style={{alignSelf:'stretch',gap:'24px',display:'flex',flexDirection:'column'}}>
            {disabledParam==true?
                <h4 className='titlesociete'>{i18n.t('Régularisation-Prestation normale')}</h4>
                :
                <h4 className='titlesociete'>{i18n.t('Faire une régularisation-Prestation normale')}</h4>
            }
            <NomRefRgularisationNormal
                refCra={refCra}
                setRefCra={setRefCra}
                refMission={refMission??''}
                nomClient={nomClient??''}
                refClient={refClient??''}
                refExpert={refExpert??''}
                nomExpert={nomExpert??''}
                refCmdClient={refCmdClient}
                refIntClient={refIntClient}
                setRefIntClient={setRefIntClient}
                mode={disabledParam ? 'readOnly' : ''}
            />

            <div className="FrameBox0Reg">
                {!disabledParam &&
                    <FormControl >
                        <RadioGroup
                            style={{display:'flex',flexDirection:'row',gap:'16px'}}
                            value={ajoutDeduire}
                            onChange={(e)=>{
                                SetAjoutDeduire(e.target.value);
                            }}
                            disabled={disabledParam}
                        >
                            <FormControlLabel
                                value="deduire"
                                control={<Radio />}
                                checked={ajoutDeduire === 'deduire'}
                                style={{
                                    fontFamily: 'Lato',
                                    fontStyle: 'normal',
                                    fontWeight: '400',
                                    fontSize: '16px',
                                    lineHeight: '24px',
                                    letterSpacing: '-0.0044em',
                                    color: '#475063',
                                }}
                                label={i18n.t('Déduire')}
                            />

                            <FormControlLabel
                                value="ajouter"
                                control={<Radio />}
                                checked={ajoutDeduire === 'ajouter'}
                                style={{
                                    fontFamily: 'Lato',
                                    fontStyle: 'normal',
                                    fontWeight: '400',
                                    fontSize: '16px',
                                    lineHeight: '24px',
                                    letterSpacing: '-0.0044em',
                                    color: '#475063',
                                }}
                                label={i18n.t('Ajouter')}
                            />

                        </RadioGroup>
                        {/*<FormHelperText>{showErrors && (error?? '')}</FormHelperText>*/}
                    </FormControl>
                }
                <div className="FrameBox1Reg">
                    <div className="FrameBox2Reg">
                        <label className='AjouterDiplomeFrame7'>{i18n.t('Nombre de jours')} </label>
                        <TextFieldComponent
                            sx={{
                                '& > :not(style)': {borderRadius: '8px' },
                            }}
                            value={nbrJour}
                            onChange={(event)=>{
                                setNbrJour(event.target.value);}}
                            name="tauxJournalierExpert"
                            disabled={disabledParam}
                        />
                    </div>
                    <div className="FrameBox2Reg">
                        <label className='AjouterDiplomeFrame7'>{i18n.t('Date')}</label>
                        {/*<DatePickerComponent
                            views={['month', 'year']}
                            //label="Date de début souhaitée"
                            value={date}
                            onChange={(newValue) => {
                                setDate(newValue);
                            }}
                            width={'100%'}
                        />*/}

                        <TextFieldComponent
                            sx={{
                                '& > :not(style)': {borderRadius: '8px' },
                            }}
                            value={date}
                            disabled
                            name="date"
                        />

                    </div>
                </div>
                {(role=='client' ||role=='admin') &&
                    <div className="FrameBox1Reg">
                        <div className="FrameBox2Reg">
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Taux journalier/Client')} </label>
                            <IconTextField
                                sx={{
                                    '& > :not(style)': {borderRadius: '8px' },
                                }}
                                iconEnd={'€'}
                                //InputProps={{
                                //    endAdornment: (<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">€</InputAdornment></div>),
                                //}}
                                value={tjClient}
                                //onChange={(e) => {
                                //    setTjClient(e.target.value);
                                //}}
                                disabled
                                name="tauxJournalierClient"
                            />
                        </div>

                        <div className="FrameBox2Reg">
                            <label className='AjouterDiplomeFrame7'>{i18n.t('Montant total HT/client')} *</label>
                            <IconTextField
                                sx={{
                                    '& > :not(style)': {borderRadius: '8px' },
                                }}
                                iconEnd={'€'}
                                //InputProps={{
                                //    endAdornment: (<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">€</InputAdornment></div>),
                                //}}
                                value={TotalClient}
                                //onChange={(e) => {
                                //    setTotalClient(e.target.value);
                                //}}
                                disabled
                                name="montantHtClient"
                            />
                        </div>
                    </div>
                }
                {(role=='expert' ||role=='admin') &&
                <div className="FrameBox1Reg">
                    <div className="FrameBox2Reg">
                        <label className='AjouterDiplomeFrame7'>{i18n.t('Taux journalier/Expert')} </label>
                        <IconTextField
                            sx={{
                                '& > :not(style)': {borderRadius: '8px' },
                            }}
                            iconEnd={'€'}
                            //InputProps={{
                            //    endAdornment:(<div className='iconStyleStartAdornment iconStyleEndAdornment'> <InputAdornment position="end">€</InputAdornment></div>),
                            //}}
                            value={tjExpert}
                            disabled
                            //onChange={(e) => {
                            //    setTjExpert(e.target.value);
                            //}}
                            name="tauxJournalierExpert"
                        />
                    </div>
                    <div className="FrameBox2Reg">
                        <label className='AjouterDiplomeFrame7'>{i18n.t('Montant total HT/Expert')} *</label>
                        <IconTextField
                            sx={{
                                '& > :not(style)': {borderRadius: '8px' },
                            }}
                            value={TotalExpert}
                            iconEnd={'€'}
                            //InputProps={{
                            //    endAdornment: (<div className='iconStyleStartAdornment iconStyleEndAdornment'><InputAdornment position="end">€</InputAdornment></div>),
                            //}}
                            //onChange={(e) => {
                            //    setTotalExpert(e.target.value);
                            //}}
                            disabled
                            name="montantHtExpert"
                        />
                    </div>
                </div>
                }
            </div>

            <div className="FrameBox0Reg">
                <h6 className='nomPrenomProfile'>
                    {i18n.t('Ajouter des détails')}
                </h6>
                <TextFieldComponent
                    multiline
                    sx={{
                        '& > :not(style)': { borderRadius: '8px' },
                    }}
                    value={detail}
                    onChange={(e) => {
                        setDetail(e.target.value);
                    }}
                    disabled={disabledParam}
                    //value={syntheseProfile}
                    //onChange={(e) => {
                    //    if (!CompareTwoString(e.target.value, firstDataFromBackend?.persoData?.syntheseProfile)) {
                    //        setWasValuesUpdated(false);
                    //    }
                    //    setSyntheseProfile(e.target.value);
                    //}}
                    //disabled={typeTraitement == 'readOnly' ? true : false}
                    style={{ width: '100%', background: 'white', borderRadius: '8px' }}
                    rows={4}
                    maxRows={5}
                />
            </div>
            {!disabledParam &&
                <div className="FrameBox3Reg">
                    <Button
                        variant="outlined"
                        style={{...buttonStyles()}}
                        //style={{
                        //    borderRadius: '8px',
                        //    fontFamily: 'Lato',
                        //    fontStyle: 'normal',
                        //    fontWeight: '600',
                        //    fontSize: '14px',
                        //    height:'56px',
                        //    lineHeight: '20px',
                        //}}
                        onClick={() => {
                            navigate(-1);
                        }}
                    >
                        {i18n.t('Annuler')}
                    </Button>

                    <Button
                        variant="contained"
                        style={{...buttonStylesGreen()}}
                        //style={{
                        //    background: '#5CC889',
                        //    borderRadius: '8px',
                        //    fontFamily: 'Lato',
                        //    fontStyle: 'normal',
                        //    fontWeight: '600',
                        //    fontSize: '14px',
                        //    height:'56px',
                        //    lineHeight: '20px',
                        //    color:'white'
                        //}}
                        type="submit"
                        onClick={(e) => {
                            createRegNormal(e);
                        }}

                    >
                        {i18n.t('Valider')}
                    </Button>
                </div>
            }

        </form>

    );

};
export default RegularizationNormal;